import badgeStart from '../assets/notifications/badge-start.svg';
import badgeResult from '../assets/notifications/badge-result.svg';
import badgeBirdie from '../assets/notifications/badge-birdie.svg';
import badgeEagle from '../assets/notifications/badge-eagle.svg';

/**
 * The artwork for each event, keyed by the `badge` the SERVER sends
 * (`push_sender.PushNotification.badge`). One map, because the settings screen
 * and the in-app pill must not drift on which picture means which event.
 *
 * An eagle, albatross and hole-in-one all wear the eagle badge — that is the
 * server's decision, made in `highlight_tier`, not a gap here.
 */
export const BADGES = {
  start: badgeStart,
  result: badgeResult,
  birdie: badgeBirdie,
  eagle: badgeEagle,
};

/**
 * The accent each event's label is written in, inside the pill's eyebrow.
 * Spec §6. These are notification-only and deliberately NOT app tokens: they
 * read against the pill's near-black glass, nothing else.
 */
export const BADGE_ACCENTS = {
  start: '#7FB0FF',
  birdie: '#FF8A7E',
  eagle: '#E8BD55',
  result: '#D9BB7E',
};

export const badgeFor = (key) => BADGES[key] || BADGES.start;
export const accentFor = (key) => BADGE_ACCENTS[key] || BADGE_ACCENTS.start;
